module.exports = __webpack_public_path__ + "pt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/pt.svg
// module id = 770
// module chunks = 0